module.exports = __webpack_public_path__ + "static/img/06OK.744f20c6.gif";